import { render } from "./CoursePreparationAdd.vue?vue&type=template&id=13a1cb24"
import script from "./CoursePreparationAdd.vue?vue&type=script&lang=js"
export * from "./CoursePreparationAdd.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__